import { useEffect, useEffectEvent, useReducer } from 'react';
import {
  createInitialState,
  SearchMode,
  searchModeReducer,
} from '~/purchase/reducers';

export type { SearchMode };

type Args = {
  rawIdentifier: string | null | undefined;
  identifierValue: string | null | undefined;
  onSwitchToManual: () => void;
  initialMode?: SearchMode;
};

export const useSearchMode = ({
  rawIdentifier,
  identifierValue,
  onSwitchToManual,
  initialMode,
}: Args) => {
  const [modeState, dispatch] = useReducer(
    searchModeReducer,
    createInitialState(initialMode),
  );

  const handleSwitchToManual = useEffectEvent(() => {
    onSwitchToManual();
  });

  useEffect(() => {
    if (rawIdentifier || identifierValue) {
      dispatch({ type: 'SWITCH_TO_FAST' });
    } else {
      dispatch({ type: 'SWITCH_TO_MANUAL' });
      handleSwitchToManual();
    }
  }, [rawIdentifier, identifierValue]);

  return { isQuickSearch: modeState.mode === 'fast' };
};
